import { Outlet } from "react-router-dom";
import { VendorList } from "./VendorList";
import VendorForm from "./VendorForm";

export const vendorsRoutes = [
  {
    path: "vendors",
    element: Outlet,
    children: [
      {
        path: "",
        element: VendorList,
      },
      {
        path: "add",
        element: VendorForm,
      },
      {
        path: "edit/:id",
        element: VendorForm,
      },
    ],
  },
];
